import { useAdminGetDownloadSignedUrlForExamCenterProctorRequestQuery } from '@exam-center/graphql';

import {
  type ProctorRequestStorageObject,
  useProctorRequestFileNames,
  useProctorRequestFilesWithInfo,
} from '../use-proctor-request-files-with-info';

interface UseAdminGetProctorRequestDownloadSignedUrlWithInfoProps {
  examCenterProctorRequestId: string;
  proctorRequestStorageObject: ProctorRequestStorageObject[];
  options?: {
    skip?: boolean;
  };
}

export function useAdminGetProctorRequestDownloadSignedUrlWithInfo(
  params: Readonly<UseAdminGetProctorRequestDownloadSignedUrlWithInfoProps>,
) {
  const {
    examCenterProctorRequestId,
    proctorRequestStorageObject,
    options: { skip: shouldSkip = false } = {},
  } = params;

  const fileNames = useProctorRequestFileNames(proctorRequestStorageObject);

  const { data } = useAdminGetDownloadSignedUrlForExamCenterProctorRequestQuery({
    variables: {
      getDownloadSignedUrlForExamCenterProctorRequestInput: {
        examCenterProctorRequestId,
        fileNames,
      },
    },
    fetchPolicy: 'no-cache',
    skip: shouldSkip,
  });

  return useProctorRequestFilesWithInfo(
    proctorRequestStorageObject,
    fileNames,
    data?.ecAdminGetDownloadSignedUrlForExamCenterProctorRequest.signedUrls,
  );
}
